
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2 2l2.94 2.94A9.944 9.944 0 002 12c0 5.514 4.486 10 10 10s10-4.486 10-10S17.514 2 12 2v2c4.411 0 8 3.589 8 8s-3.589 8-8 8-8-3.589-8-8c0-2.206.9-4.203 2.35-5.65L9 9V2H2z"}})])
          )
        }
      }
    